import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "XlMinus"
});
const _hoisted_1 = {
  t: "1663917800577",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "30310",
  width: "200",
  height: "200"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M581.3248 442.6752H896c17.664 0 32 14.336 32 32v74.6496c0 17.664-14.336 32-32 32h-768a32 32 0 0 1-32-32V474.6752c0-17.664 14.336-32 32-32h453.3248z",
  "p-id": "30311",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var xlMinus = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xlMinus as default };
